import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Contents} from "../../../components";
import PrevIcon from "../../../../assets/images/icon/PrevIcon";
import {AddChapter, Col, FormBox, ProfileFormBoxItemWrap, FormItem, Row} from "../../../../styled/StyledComponent";
import {teachersAPI} from "../../../../api/teachersAPI";
import {SpacingV} from "../../InstructorApp/component/common/Spacing";
import {CheckBox} from "../../../components/common/CheckBox";
import EyeIcon from "../../../../assets/images/icon/EyeIcon";
import CheckBlueIcon from "../../../../assets/images/icon/CheckBlueIcon";
import CloseRedIcon from "../../../../assets/images/icon/CloseRedIcon";
import EyeOpen from "../../../../assets/images/icon/EyeOpen";

const EditPasswordPopup = (props) => {
    const [changeData, setChangeData] = useState({
        email:"",
        password:"",
    })
    const [passwordData, setPasswordData] = useState({
        currentPassword:"",
        newPassword:"",
        reTypePassword:""
    })
    const [inputType, setInputType] = useState({
        current:false,
        new:false,
        reType:false
    })
    const [verifyCode, setVerifyCode] = useState("");
    const [render, setRender] = useState(false)
    const [renderCode, setRenderCode] = useState(false);
    const [editPage ,setEdit] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const [require, setRequire] = useState(false)

    const handlePasswordChange = (e) => {
        const newPassword = e.target.value;
        // 패스워드가 6자 이상인지 확인
        setIsValid(newPassword.length >= 6);
    };
    const postChangePw = async () => {
        await teachersAPI.postChangePw({
            data:{
                password:passwordData.newPassword
            }
        })
            .then(res => {
                console.log("@res",res);
                if(res?.success === true){
                    props.getProfile();
                    props.onToastPopup();
                    props.onClickPopup();
                }else{
                    alert("error")
                }
            })
    }

    useEffect(() => {
        setTimeout(()=> {
            setEdit(false)
            setTimeout(()=>{
                setRender(true)
            },100)
        },100)
    }, []);
    return(
        <Container>
            <Contents title={render === true ? "Edit Account" : "Code Verification"}>
                {/*"Code Verification"*/}
                <Inner className={render === true ? "on" : ""}>
                    <BackButton
                        onClick={()=>{
                            setChangeData({
                                email:"",
                                password:"",
                            })
                            setVerifyCode("")
                            props.onClickPopup();
                        }}
                    >
                        <PrevIcon/>
                        <span>
                    Back
                </span>
                    </BackButton>
                    <h1>
                        Change password
                    </h1>
                    <p style={{marginBottom:40, color:"rgba(51, 51, 51, 0.8)"}}>
                        Create a new password that is at least 6 characters long.
                    </p>
                    <Row display={"flex"} style={{width: "100%", alignItems:"center"}}>
                        <Col className={"col"} style={{width: "80%",}}>
                            <FormBox>
                                <dt>
                                    Type your current password<strong>*</strong>
                                </dt>
                                <dd>
                                    <ProfileFormBoxItemWrap>
                                        <li>
                                            <FormItem>
                                                <input
                                                    onChange={(e)=>{
                                                        setPasswordData({
                                                            ...passwordData,
                                                            currentPassword:e.target.value
                                                        })
                                                    }}
                                                    value={passwordData.currentPassword}
                                                    type={inputType.current ? "text" : "password"}
                                                    autoComplete="new-password"
                                                    placeholder={"Type your current password"}/>
                                                <IconWrap
                                                    onClick={()=>{
                                                        setInputType({
                                                            ...inputType,
                                                            current: !inputType.current
                                                        })
                                                    }}
                                                    style={{right:20}}>
                                                    {
                                                        inputType.current ?  <EyeIcon/> :  <EyeOpen/>
                                                    }
                                                </IconWrap>
                                            </FormItem>
                                        </li>
                                    </ProfileFormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Col>
                    </Row>
                    <SpacingV height={15} />
                    <Row display={"flex"} style={{width: "100%", alignItems:"center"}}>
                        <Col className={"col"} style={{width: "80%",}}>
                            <FormBox>
                                <dt>
                                    Type your new password<strong>*</strong>
                                </dt>
                                <dd>
                                    <ProfileFormBoxItemWrap>
                                        <li>
                                            <FormItem>
                                                <input
                                                    onChange={(e)=>{
                                                        handlePasswordChange(e);
                                                        setPasswordData({
                                                            ...passwordData,
                                                            newPassword:e.target.value
                                                        })
                                                    }}
                                                    value={passwordData.newPassword}
                                                    type={inputType.new ? "text" : "password"}
                                                    placeholder={"Password"}/>
                                                {
                                                    passwordData.newPassword.length !== 0 &&
                                                    <IconWrap style={{right:20}}>
                                                        {
                                                            isValid ?
                                                        <CheckBlueIcon/>
                                                                :
                                                        <CloseRedIcon/>
                                                        }
                                                    </IconWrap>
                                                }
                                                <IconWrap
                                                    onClick={()=>{
                                                        setInputType({
                                                            ...inputType,
                                                            new: !inputType.new
                                                        })
                                                    }}
                                                    style={{right:passwordData.newPassword.length === 0 ? 20 : 50}}>
                                                    {
                                                        inputType.new ? <EyeIcon/> :  <EyeOpen/>
                                                    }
                                                </IconWrap>
                                            </FormItem>
                                        </li>
                                    </ProfileFormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Col>
                    </Row>
                    <SpacingV height={15} />
                    <Row display={"flex"} style={{width: "100%", alignItems:"center"}}>
                        <Col className={"col"} style={{width: "80%",}}>
                            <FormBox>
                                <dt>
                                    Re-type your new password<strong>*</strong>
                                </dt>
                                <dd>
                                    <ProfileFormBoxItemWrap>
                                        <li>
                                            <FormItem>
                                                <input
                                                    onChange={(e)=>{
                                                        setPasswordData({
                                                            ...passwordData,
                                                            reTypePassword:e.target.value
                                                        })
                                                    }}
                                                    type={inputType.reType ? "text" : "password"}
                                                    placeholder={"Password"}/>
                                                {
                                                    passwordData.reTypePassword.length !== 0 &&
                                                    <IconWrap style={{right:20}}>
                                                        {
                                                            passwordData.reTypePassword === passwordData.newPassword ?
                                                                <CheckBlueIcon/>
                                                                :
                                                                <CloseRedIcon/>
                                                        }
                                                    </IconWrap>
                                                }
                                                <IconWrap
                                                    onClick={()=>{
                                                        setInputType({
                                                            ...inputType,
                                                            reType: !inputType.reType
                                                        })
                                                    }}
                                                    style={{right:passwordData.reTypePassword.length === 0 ? 20 : 50}}>
                                                    {
                                                        inputType.reType ? <EyeIcon/> :  <EyeOpen/>
                                                    }
                                                </IconWrap>
                                            </FormItem>
                                        </li>
                                    </ProfileFormBoxItemWrap>
                                </dd>
                                <div className="check" onClick={()=>{setRequire(v => !v)}}>
                                    <CheckBox state={require} onClick={()=>{}} />
                                    <p>Require all devices to sign in with your new password</p>
                                </div>
                            </FormBox>
                        </Col>
                    </Row>

                    <AddChapter
                        className={passwordData.reTypePassword !== passwordData.newPassword ||
                            isValid === false || passwordData.newPassword.length === 0
                            ? "off" : ""}
                        style={{
                            width:166,
                            marginTop:50
                        }}
                        onClick={()=>{
                            if(require === true) {
                                postChangePw()
                            }
                        }}
                    >
                <span style={{marginRight:0}} >
                    Save password
                </span>
                    </AddChapter>
                </Inner>
            </Contents>

        </Container>
    )

}
export default EditPasswordPopup;

const Container = styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -55%);
    width: 700px;
    @media screen and (max-width: 768px) {
        width: 96%;
        .col{
            width: 100% !important;
        }
    }
    .commonContents{
        overflow: hidden;
    }
    .off{
        opacity: 0.6;
        pointer-events: none;
    }
    .check{
        display: flex;
        align-items: center;
        p{
            cursor: pointer;
            margin-left: 10px;
            font-family: Europa-Regular;
            font-size: 16px;
            font-weight: 400;
            line-height: 21px;
            letter-spacing: 0em;
            text-align: left;
            color: rgba(51, 51, 51, 1);
        }
    }
    h1{
        font-family: Europa-Bold;
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0em;
        text-align: left;
        color: #333;
        margin-bottom: 20px;
    }
`;
const BackButton = styled.div`
    font-family: Europa-Regular;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0em;
    text-align: left;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 20px;
    span{
       margin-left: 10px; 
       color: #5A5A5A;
   }
`
const Inner = styled.div`
    padding: 20px 20px 10px 20px;
    transition: all 0.2s;
    transform: translateX(-10%);
    opacity: 0;
    @media screen and (max-width: 768px) {
        max-height: 500px;
        overflow-y: auto;

    }
    &.on{
        transform: none;
        opacity: 1;
    }
    .resend{
        font-family: Europa-Bold;
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        color: #DDC160CC;
        cursor: pointer;
    }
    .guide{
        font-family: Europa-Regular;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        color: #33333399;
    }
`
const IconWrap = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
`